// extracted by mini-css-extract-plugin
export default {"image":"ImageFull_image__uuxj4","Md":"ImageFull_Md__5KvEY","Sm":"ImageFull_Sm__98SUl","Lg":"ImageFull_Lg__kyvxy","Xs":"ImageFull_Xs__-w-Zd"};